import { AlertTriangleIcon, Router, RouterIcon, TriangleAlert } from 'lucide-react';
import React from 'react';

interface StatusPanelProps {
  isAlarm: boolean;
  alarmCode: string;
  connectionStatus: 'online' | 'offline';
}

export function StatusPanel({ isAlarm, alarmCode, connectionStatus }: StatusPanelProps) {
  return (
    <div className="flex gap-2 shadow-card bg-white rounded-[12px] px-3 py-2 border border-light-grey">
      <div className="flex-1 gap-0.5">
        <div className="flex items-center gap-1 mb-1">
          <Router className='w-4 h-4 text-light-orange' />
          <span className="text-dark-grey paragraph-12">Connection</span>
        </div>
        {connectionStatus === 'online' ? (
          <div className="h-6 py-0.5 px-1.5 bg-bg rounded-md border border-white-blue flex items-center justify-center">
            <span className="text-primary paragraph-12">Online</span>
          </div>
        ) : (
          <div className="h-6 py-0.5 px-1.5 bg-heatmap-hot rounded-md border border-danger02 flex items-center justify-center">
            <span className="text-danger paragraph-12">Offline</span>
          </div>
        )}
      </div>

      <div className="flex-1 gap-0.5">
        <div className="flex items-center gap-1 mb-1">
          <TriangleAlert className='w-4 h-4 text-danger' />
          <span className="text-dark-grey paragraph-12">Alarm</span>
        </div>
        {
          isAlarm ?
            <div className="h-6 py-0.5 px-1.5 bg-heatmap-hot rounded-md border border-danger02 flex items-center justify-center">
              <span className="text-danger paragraph-12">{alarmCode}</span>
            </div> :
            <div className="h-6 py-0.5 px-1.5 bg-bg rounded-md border border-white-blue flex items-center justify-center">
              <span className="text-primary paragraph-12">None</span>
            </div>
        }
      </div>
    </div>
  );
}